import { render, staticRenderFns } from "./ProgressBarSimulation.vue?vue&type=template&id=2f486eb7&scoped=true&"
import script from "./ProgressBarSimulation.vue?vue&type=script&lang=ts&"
export * from "./ProgressBarSimulation.vue?vue&type=script&lang=ts&"
import style0 from "./ProgressBarSimulation.vue?vue&type=style&index=0&id=2f486eb7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f486eb7",
  null
  
)

export default component.exports